import React, { useEffect, useState, useContext, useRef } from "react";
import InternetChecking from "../Reusablecomponents/Network";
import CopyRight from "../Reusablecomponents/Copyright";
import axiosInstance from "../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { FaGreaterThan, FaLessThan } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";
import { PiSpeakerSimpleHighFill } from "react-icons/pi";
import { Row, Col } from "react-bootstrap";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import { useLocation, useNavigate } from "react-router-dom";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { SubjectIds } from "../../ReusableComponents/CommonFunctions";
import NSFLOgo from "../Assests/Images/NSFLOgo.jpg";
import NCLLOgo from "../Assests/Images/NCLogo.png";
import SamagraPieChart from "./SamagraPieChart";
import { FaStar } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import { Icon } from "@iconify/react";
const SamagraLO = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const SamagraReportsRef = useRef();
    const TeacherStudent = JSON.parse(localStorage.getItem("T2S"));
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const HQNDetails = JSON.parse(localStorage.getItem("HQNVLO"));
    const { SetLoad } = useContext(LoadContext);

    const [SLGrade, SetSLGrade] = useState();
    const [SelectSub, SetSelectSub] = useState();
    const [PState, SetPSTate] = useState();
    const [LODetails, SetLODetails] = useState();

    const [ALLSUBLo, SetALLSUBLo] = useState({});


    const GetStudentGradeLevel = async () => {
        try {
            const res = await axiosInstance.get(`/StudentResults/StudentGradeLevelBasedReport?ContestCreationId=${location.state.CCID}&UserId=${location.state?.userId || items.userId}`);
            SetSLGrade(res.data);
            GetAllSUbjetsLO(res.data);
            SetSelectSub(res.data[0].subjectName);
            GetLOPerformance(res.data[0].subjectName);
        }
        catch (err) {
            console.log(err);
        }
    }; 
    const GetLOPerformance = async (Sub, loadAll = false) => {
        if (!loadAll) SetLoad(prev => !prev);
        try {
            const res = await axiosInstance.get(`/StudentResults/GetSubjectWiseLOPerformance?SubjectName=${Sub}&ContestCreationId=${location.state.CCID}&UserId=${location.state?.userId || items.userId}&Type=3&LanguageId=${location?.state?.Medium || items.mediumId}`);

            if (!loadAll) {
                SetLODetails(res.data);
                const Datasample = res.data.reduce((acc, item) => {
                    const grade = item.grade;

                    if (item.status === "Strength") {
                        if (!acc.strengths[grade]) acc.strengths[grade] = [];
                        acc.strengths[grade].push(item);
                    }

                    if (item.status === "Improvement") {
                        if (!acc.improvements[grade]) acc.improvements[grade] = [];
                        acc.improvements[grade].push(item);
                    }
                    return acc;
                }, { strengths: {}, improvements: {} });
                SetPSTate(Datasample);
                SetLoad(prev => !prev);
            } else {
                SetALLSUBLo(prev => ({
                    ...prev,
                    [Sub]: res.data
                }));

            }

        }
        catch (err) {
            console.log(err)
        }
    }
    useEffect(() => { GetStudentGradeLevel(); }, [])

    const GotoPreviousSUbject = () => {
        const index = SLGrade.findIndex((sub) => sub.subjectName === SelectSub);
        if (index > 0) {
            SetSelectSub(SLGrade[index - 1]?.subjectName);
            GetLOPerformance(SLGrade[index - 1]?.subjectName);
        }
    };
    const GotoNextSUbject = () => {
        const index = SLGrade.findIndex((sub) => sub.subjectName === SelectSub);
        if (index !== -1 && index < SLGrade?.length - 1) {
            SetSelectSub(SLGrade[index + 1]?.subjectName);
            GetLOPerformance(SLGrade[index + 1]?.subjectName);
        }
    };

    const NavigateRamidation = (
        Subject,
        GradeName,
        ChapterName,
        LovId,
        loName,
        LisTables
    ) => {
        const Params = {
            AssCode: location.state.Date,
            SubjectName: Subject,
            loName: loName,
            SubId: SubjectIds(SelectSub),
            Grade: GradeName,
            Chapter: ChapterName,
            LovId: LovId,
            UserType: 12,
            RTables: LisTables,
        };

        localStorage.setItem("StudentRemidation", JSON.stringify(Params));
        navigate(`/LoPerformanceReport/Remediation`);
    };
    const replaceCanvasWithImages = () => {
        const canvases = document.querySelectorAll("canvas");
        canvases.forEach((canvas) => {
            const img = document.createElement("img");
            img.src = canvas.toDataURL("image/png");
            img.style.width = canvas.style.width;
            img.style.height = canvas.style.height;
            img.className = "chart-image";
            canvas.replaceWith(img);
        });
    };

    const copyAllStyles = () => {
        let styles = "";
        for (let sheet of document.styleSheets) {
            try {
                if (sheet.href) {
                    styles += `<link rel="stylesheet" href="${sheet.href}" />`;
                } else if (sheet.cssRules) {
                    // inline style blocks (used by SCSS injected styles)
                    let rules = "";
                    for (let rule of sheet.cssRules) {
                        rules += rule.cssText;
                    }
                    styles += `<style>${rules}</style>`;
                }
            } catch (err) {
                console.log("Skipping stylesheet", err);
            }
        }
        return styles;
    };

    const DownloadPDF = () => {
        const stylesheets = copyAllStyles();
        replaceCanvasWithImages();
        const printContents = SamagraReportsRef.current.innerHTML;
        const printWindow = window.open("", "", "height=800,width=600");
         const filename = `${TeacherStudent?.AssessmentTypeName}_LOPerformance_${TeacherStudent?.StudentRollno || items?.studentId}`;
        printWindow.document.write(`
    <html>
      <head>
      ${stylesheets}
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 25px;
              position: relative;
            }
  .print-only {
    display: block !important;
  }
     
    table th {
  background-color: #025f9e !important; /* your theme color */
  color: #f6fffe !important;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 80px;
              color: rgba(0, 0, 0, 0.06); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  gap: 20px;
  margin-bottom:10px;
}
  .Details-Div{
  display: flex;
    flex-direction: column;
  justify-content: space-between;
  white-space: nowrap;
  gap: 20px;
  margin-bottom:10px;
  font-size: 18px;
  }
 .PDFhide{
      display:none;}
.Icons-Div div,.Details-Div div {
  flex: 1;
  text-align: center;
}
.Icons-Div img {
              width: 25%;
            }
            .Options  {
              display: flex !important; 
              align-items: center;
              gap: 8px;
              line-height: 1.4;
              page-break-inside: avoid;
              margin: 4px 0;
            }

            .Options > span  {
              display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
            }
.alignitems{
  display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
}
      
            /* Ensure watermark appears on every page */
            @page {
              size: auto;
              margin: 15mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="Icons-Div">
       <img src="${NSFLOgo}" alt="NSF Logo"/>
     
       <img src="${NCLLOgo}" alt="NCL Logo" />
      </div>
      <hr/>
      <div class="Details-Div"> ${TeacherStudent?.StudentName || items?.fullName} (${TeacherStudent?.StudentRollno || items?.studentId})</div>
      <div class="Icons-Div ">
        <div>SAMAGRA Performance report - ${location?.state?.Date}</div>
      </div>

        <div class="watermark">NORTH SOUTH FOUNDATION</div>
   
      ${printContents}
         <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div class="Icons-Div"> <div>**  End of the Report  **</div></div>
      <script>
          window.onload = function() {
            setTimeout(() => {
                 document.title = "${filename}";
              window.print();
              window.close();
            }, 400);
          }
        <\/script>
      </body>
    </html>
  `);
        printWindow.document.close();
    }
    const GetAllSUbjetsLO = (data) => { if (data?.length) { data.forEach(sub => { GetLOPerformance(sub.subjectName, true); }); } }
   return (<>
        <div className={`VASheet ${
          TeacherStudent ? " TeacherBgImage mb-2" : "Instructions-pages "
        }`} >
            
            <InternetChecking />
            <div className="dflex JSBetween alignitems">
                <h5 className="Vtitle">Samagra Performance Report - {location.state?.Date}</h5>
                <button className="Buttons p-2" onClick={() => DownloadPDF()} > Download Report </button>
            </div>
             {HQNDetails ? 
  <b> <span >{HQNDetails?.Region?.RegionName ? <><span className="CPointer text-decoration-underline" onClick={() => navigate(-4)} style={{ color: "#696969" }}>{HQNDetails?.Region?.RegionName}</span> {""} &gt; {""} </> : ""}</span>
            <span  >{HQNDetails?.State?.StateName ? <><span className="CPointer text-decoration-underline" onClick={() => navigate(-3)} style={{ color: "#696969" }}>{HQNDetails?.State?.StateName}</span> {""} &gt; {""}  </> : ""}</span>
            <span className="CPointer text-decoration-underline" onClick={() => navigate(-2)} style={{ color: "#696969" }}>{HQNDetails?.District?.DistrictName}</span>{""} &gt; {""}
            <span className="CPointer text-decoration-underline" style={{ color: "#696969" }}  onClick={() => navigate(-1)}>{HQNDetails?.School?.SchoolName}</span>
          </b>:""}
            <div ref={SamagraReportsRef}>
                <div className="Card mt-3 w-50" style={{ fontSize: "18px" }}>
                    <div><strong style={{ color: "#025f9e" }}>Current Grade :</strong>
                        <strong> {TeacherStudent?.Grade || items.grade} </strong></div>
                    <div><strong style={{ color: "#025f9e" }}>Assessed Grades :</strong>
                        <strong>{SLGrade?.[0]?.assessedGrades}</strong></div>
                    <div><strong style={{ color: "#025f9e" }}>Highest Mastered Grade :</strong>
                        <strong>{SLGrade?.[0]?.highestMasteredGrade}</strong></div>
                    <div><strong style={{ color: "#025f9e" }}>Score % :</strong>
                        <strong>{LODetails?.[0]?.overallPercentage}</strong></div>
                    {/* <div>
                        <strong style={{ color: "#025f9e" }}>Mastery Level :</strong>
                        <span style={{ color: 'green' }}> </span>
                    </div>
                    <div>
                        <strong style={{ color: "#025f9e" }}>Brain Booster :</strong>
                        <span style={{ color: '#444' }}></span>
                    </div> */}
                </div>

                <Row className="Card mt-3">
                    <Col className=" STudenTable mb-3">
                        <table className="Data-Table mb-2">
                            <thead>
                                <tr>
                                    <th>Student Id</th>
                                    <th>Name</th>
                                    {SLGrade?.map((item, index) => (
                                        <th key={index}>{item?.subjectName}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{TeacherStudent?.StudentRollno || items?.studentId}</td>
                                    <td>{TeacherStudent?.StudentName || items?.fullName}</td>
                                    {SLGrade?.map((item, index) => {
                                        const studentGrade = parseInt(item.grade[1]);
                                        const highestPercentage = item?.percentage;

                                        let iconToDisplay = null;
                                        if (studentGrade === 'pre-primary') {
                                            if (highestPercentage < 65) {
                                                iconToDisplay = (
                                                    <>
                                                        <FiAlertTriangle style={{ color: 'orange' }} />
                                                        <span> Needs Remediation</span>
                                                    </>
                                                );
                                            } else {
                                                iconToDisplay = (
                                                    <>
                                                        <FaStar style={{ color: 'orange' }} />
                                                        <Icon icon="fluent-emoji-flat:trophy" />
                                                    </>
                                                );
                                            }
                                        } else if ((TeacherStudent?.Grade || items.grade) === studentGrade) {
                                            if (highestPercentage < 65) {
                                                iconToDisplay = (
                                                    <>
                                                        <FiAlertTriangle style={{ color: 'orange' }} />
                                                        <span> Needs Remediation</span>
                                                    </>
                                                );
                                            } else {
                                                iconToDisplay = (
                                                    <>
                                                        <FaStar style={{ color: 'orange' }} />
                                                        <Icon icon="fluent-emoji-flat:trophy" />
                                                    </>
                                                );
                                            }
                                        } else if ((TeacherStudent?.Grade || items.grade) > studentGrade) {
                                            if (highestPercentage < 65) {
                                                iconToDisplay = (
                                                    <>
                                                        <FiAlertTriangle style={{ color: 'orange' }} />
                                                        <span> Needs Remediation</span>
                                                    </>
                                                );
                                            } else {
                                                iconToDisplay = <FaStar style={{ color: 'orange' }} />;
                                            }
                                        }

                                        return (
                                            <td key={index}>
                                                {item.grade} {iconToDisplay}
                                            </td>
                                        );
                                    })}

                                </tr>
                            </tbody>
                        </table>
                    </Col>
                    <Col>
                        <div className="SubHeading">Grade level by subject</div>
                        {SLGrade && <SamagraPieChart PChart={SLGrade} />}
                    </Col>
                </Row>

                <div className="Card mt-4 PDFhide">
                    <div className="PALOutcomes-Navigation dflex alignitems gap-3 CPointer " style={{ fontSize: '20px' }}>
                        <FaLessThan onClick={GotoPreviousSUbject}
                            style={SelectSub === SLGrade?.[0]?.subjectName ? { color: "white" } : {}} />
                        {SLGrade?.map((item) => (
                            <span onClick={() => { SetSelectSub(item.subjectName); GetLOPerformance(item.subjectName); }}
                                style={SelectSub !== item?.subjectName ? { color: "#9E9E9E" } : {}}
                            > {item?.subjectName} </span>))}
                        <FaGreaterThan onClick={() => GotoNextSUbject()}
                            style={SelectSub === SLGrade?.[1]?.subjectName ? { color: "white" } : {}} />
                    </div>



                    <div className="container-fluid mt-3">
                        <Row>
                            <Col>
                                <div className="STudenTable">
                                    <table className="Data-Table">
                                        <thead>
                                            <tr>
                                                <th>Levels</th>
                                                <th>Areas of Strength</th>
                                                <th>Remediation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {PState && Object.entries(PState?.strengths).length > 0 ? (
                                                Object.entries(PState?.strengths)?.map(([Garde, items], Mainindex) => (
                                                    items?.map((row, index) => (
                                                        <tr>
                                                            {index === 0 && <td rowSpan={items.filter(
                                                                (item) => item.status === "Strength"
                                                            ).length}>{Garde}</td>}
                                                            <td>{row.loName}</td>
                                                            <td className="no-print">
                                                                <div className="CPointer gap-1 dflex alignitems JCCenter"
                                                                // onClick={() =>
                                                                //     NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName)}
                                                                >
                                                                    <FaVideo style={{ color: row.isVideoExists ? "#025f9e" : "#808080" }}
                                                                        title={!row.isVideoExists ? "Content will show up here shortly." : ""}
                                                                        onClick={() => {
                                                                            if (!row.isVideoExists) {
                                                                                notify("File not available", "error");
                                                                            } else {
                                                                                NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName, ["Video"]);
                                                                            }
                                                                        }}
                                                                    />|
                                                                    <RiFileExcel2Fill style={{ color: row.isFileExists ? "Black" : "#808080" }}
                                                                        title={!row.isFileExists ? "Content will show up here shortly." : ""}
                                                                        onClick={() => {
                                                                            if (!row.isFileExists) {
                                                                                notify("File not available", "error");
                                                                            } else {
                                                                                NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName, ["WExamples", "Flashcards", "CSheets"]);
                                                                            }
                                                                        }} />  |
                                                                    <PiSpeakerSimpleHighFill style={{ color: row.isAudioExists ? "Black" : "#808080" }}
                                                                        title={!row.isAudioExists ? "Content will show up here shortly." : ""}
                                                                        onClick={() => {
                                                                            if (!row.isAudioExists) {
                                                                                notify("File not available", "error");
                                                                            } else {
                                                                                NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName, ["Audio"]);
                                                                            }
                                                                        }} />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )
                                                )
                                            ) :
                                                <tr>
                                                    <td colSpan="3">**No records found**</td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                            <Col>
                                <div className="STudenTable">
                                    <table className="Data-Table">
                                        <thead>
                                            <tr>
                                                <th>Levels</th>
                                                <th>Areas of Improvement</th>
                                                <th>Remediation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {PState && Object.entries(PState?.improvements).length > 0 ? (
                                                Object.entries(PState?.improvements)?.map(([Garde, items], Mainindex) =>
                                                (
                                                    items.map((row, index) => (
                                                        <tr>
                                                            {index === 0 && <td rowSpan={items.filter(
                                                                (item) => item.status === "Improvement"
                                                            ).length}>{Garde}</td>}
                                                            <td>{row.loName}</td>
                                                            <td className="no-print">
                                                                <div className="CPointer gap-1 dflex alignitems JCCenter"
                                                                // onClick={() =>
                                                                //     NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName)}
                                                                >
                                                                    <FaVideo style={{ color: row.isVideoExists ? "#025f9e" : "#808080" }}
                                                                        title={!row.isVideoExists ? "Content will show up here shortly." : ""}
                                                                        onClick={() => {
                                                                            if (!row.isVideoExists) {
                                                                                notify("File not available", "error");
                                                                            } else {
                                                                                NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName, ["Video"]);
                                                                            }
                                                                        }}
                                                                    />|
                                                                    <RiFileExcel2Fill style={{ color: row.isFileExists ? "Black" : "#808080" }}
                                                                        title={!row.isFileExists ? "Content will show up here shortly." : ""}
                                                                        onClick={() => {
                                                                            if (!row.isFileExists) {
                                                                                notify("File not available", "error");
                                                                            } else {
                                                                                NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName, ["WExamples", "Flashcards", "CSheets"]);
                                                                            }
                                                                        }} />  |
                                                                    <PiSpeakerSimpleHighFill style={{ color: row.isAudioExists ? "Black" : "#808080" }}
                                                                        title={!row.isAudioExists ? "Content will show up here shortly." : ""}
                                                                        onClick={() => {
                                                                            if (!row.isAudioExists) {
                                                                                notify("File not available", "error");
                                                                            } else {
                                                                                NavigateRamidation(row.subjectName, row.grade, row.chapter, row.loLovId, row.loName, ["Audio"]);
                                                                            }
                                                                        }} />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )
                                                )

                                            ) : (
                                                <tr>
                                                    <td colSpan="3">**No records found**</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* below is only table pdf */}

                <div className="print-only" >
                    {SLGrade?.map(({ subjectName }) => {
                        const subjectData = ALLSUBLo[subjectName];
                        if (!subjectData) return null;

                        const grouped = subjectData.reduce((acc, item) => {
                            const grade = item.grade;
                            if (item.status === "Strength") {
                                (acc.strengths[grade] ||= []).push(item);
                            }
                            if (item.status === "Improvement") {
                                (acc.improvements[grade] ||= []).push(item);
                            }
                            return acc;
                        }, { strengths: {}, improvements: {} });
                        return (
                            <div key={subjectName} className="Card STudenTable mt-5">
                                <div className="SubHeading mt-3 mb-3"> {subjectName} </div>
                                {/* Strength Table */}

                                <table className="Data-Table w-100">
                                    <thead>
                                        <tr><th>Level</th><th>Strengths</th></tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(grouped?.strengths).length > 0 ? Object.entries(grouped?.strengths).map(([grade, items]) =>
                                            items.filter(x => x.status === "Strength").map((row, idx) => (
                                                <tr key={row.loLovId}>
                                                    {idx === 0 && <td rowSpan={items.filter(x => x.status === "Strength").length}>{grade}</td>}
                                                    <td>{row.loName}</td>
                                                </tr>
                                            ))
                                        ) :
                                            <tr>
                                                <td colSpan="3">**No records found**</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>

                                {/* Improvement Table */}
                                <table className="Data-Table w-100 mt-4"  >
                                    <thead>
                                        <tr><th>Level</th><th>Improvements</th></tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(grouped?.improvements).length > 0 ? Object.entries(grouped?.improvements).map(([grade, items]) =>
                                            items.filter(x => x.status === "Improvement").map((row, idx) => (
                                                <tr key={row.loLovId}>
                                                    {idx === 0 && <td rowSpan={items.filter(x => x.status === "Improvement").length}>{grade}</td>}
                                                    <td>{row.loName}</td>
                                                </tr>
                                            ))
                                        ) :
                                            <tr>
                                                <td colSpan="3">**No records found**</td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        );
                    })}
                </div>
                {/* Above is only table pdf */}

            </div>
            {items?.userTypeId !== 2 && 
            <CopyRight />}
        </div>
    </>)
}
export default SamagraLO;